module.exports = __webpack_public_path__ + "img/es.05ec92c5.png";